angular.module('ikeweb.unit', [
    'ikeweb.user',
    'ikegps.math',
    'ikeweb.shared.decoration',
    'ikeweb.shared.notification',
    'ikeweb.spike.measure'
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/unit/unit.module.js
// module id = 441
// module chunks = 0